import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Logo2 } from '../static';
import { ChevronLeft, Home, RotateCcw, ShieldAlert } from 'lucide-react';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <>
      <style>{`
        .facturize-404-layout {
          background-color: #f9fafb;
          font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          color: #1f2937;
          -webkit-font-smoothing: antialiased;
        }

        .facturize-navbar {
          background: #ffffff;
          border-bottom: 1px solid #e5e7eb;
          padding: 14px 24px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
        }

        .brand-link {
          display: flex;
          align-items: center;
          text-decoration: none;
        }

        .brand-text {
          margin-left: 12px;
          font-weight: 800;
          color: #111827;
          font-size: 14px;
          letter-spacing: 0.05em;
        }

        .brand-subtext {
          color: #2563eb;
          font-weight: 500;
          font-size: 12px;
        }

        .facturize-btn {
          border-radius: 6px;
          border: 1px solid #d1d5db;
          background: #ffffff;
          font-size: 12px;
          font-weight: 600;
          padding: 8px 12px;
          transition: all 0.2s;
          display: flex;
          align-items: center;
          gap: 8px;
          color: #4b5563;
          cursor: pointer;
          box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
        }

        .facturize-btn:hover {
          background: #f9fafb;
          color: #111827;
          border-color: #9ca3af;
        }

        .facturize-btn:active {
          transform: scale(0.98);
        }

        .facturize-btn-primary {
          background: #2563eb;
          color: #ffffff;
          border-color: transparent;
          padding: 10px 20px;
          box-shadow: 0 4px 6px -1px rgba(37, 99, 235, 0.1);
        }

        .facturize-btn-primary:hover {
          background: #1d4ed8;
          color: #ffffff;
        }

        .error-container {
          flex-grow: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(to bottom, #ffffff 0%, #f9fafb 100%);
          padding: 24px;
        }

        .error-card {
          text-align: center;
          width: 100%;
          max-width: 512px;
        }

        .visual-container {
          position: relative;
          display: inline-block;
          margin-bottom: 16px;
        }

        .big-code {
          font-size: 128px;
          font-weight: 900;
          color: #e5e7eb;
          letter-spacing: -0.05em;
          line-height: 1;
          user-select: none;
          font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
        }

        .icon-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 32px;
        }

        .pulse-icon {
          color: #ef4444;
          animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
        }

        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: .5; }
        }

        .system-msg {
          font-size: 24px;
          font-weight: 700;
          color: #111827;
          margin-bottom: 12px;
          letter-spacing: -0.025em;
        }

        .description-text {
          font-size: 14px;
          color: #6b7280;
          max-width: 448px;
          margin: 0 auto 24px auto;
          line-height: 1.6;
        }

        .diagnostic-terminal {
          background: #111827;
          color: #d1d5db;
          border-radius: 8px;
          padding: 16px;
          text-align: left;
          font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
          font-size: 12px;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
          border: 1px solid #1f2937;
          margin: 0 auto 32px auto;
          max-width: 448px;
        }

        .terminal-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-b: 1px solid #1f2937;
          padding-bottom: 8px;
          margin-bottom: 8px;
          color: #6b7280;
          font-family: system-ui, sans-serif;
          font-weight: 600;
        }

        .terminal-dot {
          height: 8px;
          width: 8px;
          border-radius: 50%;
          background-color: #ef4444;
        }

        .terminal-line {
          margin: 4px 0;
        }

        .token-blue { color: #60a5fa; }
        .token-red { color: #f87171; }

        .actions-wrapper {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 12px;
        }

        .facturize-footer {
          background: #ffffff;
          border-top: 1px solid #e5e7eb;
          padding: 12px;
          text-align: center;
          font-size: 11px;
          font-weight: 700;
          color: #9ca3af;
          letter-spacing: 0.05em;
        }
      `}</style>

      <div className="facturize-404-layout">
        <header className="facturize-navbar">
          <Link to="/" className="brand-link">
            <img height={24} className='object-fit-cover' alt="Facturize" src={Logo2} />
            <span className="brand-text">
              FACTURIZE 
            </span>
          </Link>
          
          <button onClick={() => navigate(-1)} className="facturize-btn">
            <ChevronLeft size={15} />
            <span>Retroceder</span>
          </button>
        </header>

        <main className="error-container">
          <div className="error-card">
            
            <div className="visual-container">
              <div className="big-code">404</div>
              <div className="icon-overlay">
                <ShieldAlert size={48} className="pulse-icon" />
              </div>
            </div>

            <h1 className="system-msg">Página não localizada no sistema.</h1>
            
            <p className="description-text">
              O recurso que está a tentar aceder pode ter sido removido, 
              teve o seu nome alterado ou está temporariamente indisponível no servidor.
            </p>

            <div className="diagnostic-terminal">
              <div className="terminal-header" style={{ borderBottom: '1px solid #1f2937' }}>
                <span>DETALHES DO DIAGNÓSTICO</span>
                <span className="terminal-dot"></span>
              </div>
              <div className="terminal-line">
                <span className="token-blue">&gt; Status:</span> <span className="token-red">ERROR_PAGE_NOT_FOUND</span>
              </div>
              <div className="terminal-line" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                <span className="token-blue">&gt; Origem:</span> {window.location.pathname}
              </div>
              <div className="terminal-line">
                <span className="token-blue">&gt; Acção:</span> Verifique o endereço ou contacte o suporte.
              </div>
            </div>

            <div className="actions-wrapper">
              <button onClick={() => window.location.reload()} className="facturize-btn" style={{ padding: '10px 16px' }}>
                <RotateCcw size={14} /> Tentar Novamente
              </button>
              
              <button onClick={() => navigate('/dashboard')} className="facturize-btn facturize-btn-primary">
                <Home size={14} /> Ir para o Painel Principal
              </button>
            </div>
          </div>
        </main>

        <footer className="facturize-footer">
          FACTURIZE OS &copy; {new Date().getFullYear()} — SISTEMA DE GESTÃO E FACTURAÇÃO INTEGRADA
        </footer>
      </div>
    </>
  );
};

export default NotFound;